import navigation from "@/lang/es_MX/navigation";
import generics from "@/lang/es_MX/generics";
import questions from "@/lang/es_MX/questions";
import a11y from "@/lang/es_MX/a11y";
import velt from "@/lang/es_MX/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
